import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { getActiveClaim } from '@/hooks/use-claim-funnel-store';
import { logger } from '@/utils/logging';

const track = (step: string, params: Record<string, any> = {}, clarityStage = step) => {
    const claim = getActiveClaim();
    if (!claim) {
        return;
    }
    BetrAnalytics.trackEvent(AnalyticsEvent.CLAIM_FUNNEL_STEP, {
        step,
        claim_id: claim.claimId,
        ...params,
    });
    BetrAnalytics.setUserProperties({ claim_stage: clarityStage });
};

export const ClaimFunnelEvents = {
    ctaShown: () => track('cta_shown', { source_product: 'picks' }),
    ctaTapped: () => track('cta_tapped'),
    claimResult: (outcome: 'success' | 'failure', errorCode?: string) => {
        track(
            'claim_result',
            { outcome, ...(errorCode ? { error_code: errorCode } : {}) },
            outcome === 'success' ? 'claim_success' : 'claim_failure'
        );
        if (outcome === 'failure') {
            logger.error('[ClaimFunnel] claim failed', { error_code: errorCode });
        }
    },
    sweepsLanded: () => track('ssbk_landed'),
    modalShown: () => track('modal_shown'),
    currencySelected: (currency: 'betr_cash' | 'gold_coins') => track('currency_selected', { currency }),
    walletCredited: () => track('wallet_credited', { value: 1, currency: 'USD' }),
    creditUsed: () => track('credit_used', { value: 1 }),
};
